import InfiniteMarquee from "vanilla-infinite-marquee";

$(document).ready(function () {
	new InfiniteMarquee({
		element: ".marquee-container",
		speed: 50000,
		direction: "left",
		spaceBetween: "1.666rem",
		duplicateCount: 2,
		pauseOnHover: true,
	});
});
